import { useCallback } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { PullRequestsPage } from "@/components/pulls/pull-requests-page";
import { parsePullsSearch, type PullsSearch } from "@/components/pulls/search";

export const Route = createFileRoute("/_app/$workspaceSlug/$projectSlug/pulls")({
  // Which state is listed lives in the URL and nowhere else. Whatever the
  // URL says, this returns a page that can be drawn: it never throws.
  validateSearch: (search: Record<string, unknown>): PullsSearch => parsePullsSearch(search),
  component: PullsRoute,
});

function PullsRoute() {
  const { projectSlug } = Route.useParams();
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  const setSearch = useCallback((next: PullsSearch) => void navigate({ search: next }), [navigate]);
  // Keyed by project: the active row is one project's.
  return <PullRequestsPage key={projectSlug} search={search} onSearchChange={setSearch} />;
}
